import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import { Color } from '../../const/Const';

const ButtonSecondary = (props) => {

    let vFull = {};
    if (props.full) {
        vFull = {
            width: '100%'
        }
    }

    var vBackColor = Color.white;

    if (props.backgroundcolor) {
        vBackColor = props.backgroundcolor;
    }

    var vBorder = "1px solid #C6C6C6";

    if (props.bordercolor) {
        vBorder = '1px solid ' + props.bordercolor;
    }

    var vColor = Color.black;

    if (props.color) {
        vColor = props.color;
    }

    let vIcon = {};

    if (props.icon) {
        vIcon = {
            onRenderIcon: () => {
                return (props.icon);
            }
        }
    }

    let vRadius = {};

    if (props.radius) {
        vRadius = props.radius;
    }

    return (
        <div>
            <PrimaryButton style={{ backgroundColor: vBackColor, border: vBorder, ...vFull, color: vColor, borderRadius: vRadius }} text={props.text} onClick={props.onClick} {...vIcon} />
        </div>
    );
}

export default ButtonSecondary;